import { Spacer } from "@/components/Spacer";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export default function Section07({ isMobile }: { isMobile: boolean }) {
  return (
    <div className="w-full flex flex-col items-center bg-[#F5F6FA] desktop:py-[160px] desktop:px-[20px] py-[80px] px-[24px]">
      <motion.div
        id="w-01"
        className="desktop:w-[960px] w-[342px] flex flex-col relative"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{
          type: "spring",
          stiffness: 300,
          damping: 100,
          mass: 1,
          delay: 0.1,
        }}
      >
        <img
          src="assets/images/section-07-01-desktop.png"
          alt="section-07-01"
          className="desktop:w-[634px] desktop:h-[422px] w-full h-[228px]"
        />
        <Spacer height={isMobile ? 24 : 100} />
        <div
          className="font-pre-bold text-[#5364F2] leading-[1.2em] desktop:text-[20px] text-[14px] text-start"
          style={{ letterSpacing: "-0.02em" }}
        >
          병원 대기에 지치셨나요?
        </div>
        <Spacer height={12} />
        <div className="whitespace-pre-line font-pre-bold text-[#17191C] leading-[140%] desktop:text-[32px] text-[20px] text-start">
          나의 건강상태를 미리 전달하고{"\n"}빠르게 진료받아요
        </div>
        <Spacer height={16} />
        <div
          className="whitespace-pre-line font-pre-medium text-[#2E323A] leading-[140%] desktop:text-[18px] text-[15px] text-start"
          style={{ letterSpacing: "-0.02em" }}
        >
          헬시어는 AI 증상감별 결과를 기반으로 자동으로
          {isMobile ? "\n" : ""}의료차트를 만들어요.
          {isMobile ? "\n" : ""} {isMobile ? "" : "\n"}
          의사선생님께 미리 의료차트를 전송해,{isMobile ? "\n" : ""} 빠르고
          정확하게 진료를 볼 수 있어요.
        </div>

        <img
          src="assets/images/section-07-02-desktop.png"
          alt="section-07-02"
          className="desktop:w-[723px] desktop:h-[540px] overflow-visible desktop:absolute desktop:left-[516px] desktop:bottom-[0px] desktop:block hidden"
        />
      </motion.div>

      <Spacer height={isMobile ? 40 : 80} />
      <motion.div
        id="w-02"
        className="desktop:w-[960px] w-[342px] flex desktop:flex-row flex-col desktop:gap-[20px]"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{
          type: "spring",
          stiffness: 300,
          damping: 100,
          mass: 1,
          delay: 0.1,
        }}
      >
        <div className="desktop:w-[635px]w-full">
          <img
            src="assets/images/section-07-03-dekstop.png"
            alt="section-07-03"
            className="desktop:w-[635px] desktop:h-[425px] w-full h-[229px]"
          />
          <Spacer height={isMobile ? 16 : 24} />
          <div className="font-pre-bold text-[#17191C] leading-[140%] desktop:text-[34px] text-[22px] text-start whitespace-pre-line">
            환자 뿐만 아니라{"\n"}의료진도 간편하게 사용할 수 있어요
            <Spacer height={isMobile ? 40 : 161} />
          </div>
        </div>
        <div className="desktop:w-[305px] w-full flex desktop:flex-col flex-row desktop:justify-end gap-[16px]">
          <img
            src="assets/images/section-07-04-desktop.png"
            alt="section-07-04"
            className="desktop:w-[305px] desktop:h-[435px] w-[194px] h-[276px]"
          />
          <div
            className="desktop:w-max font-pre-medium text-[#2E323A] leading-[140%] desktop:text-[20px] text-[16px] text-start whitespace-pre-line"
            style={{ letterSpacing: "-0.02em" }}
          >
            접수 대기,{isMobile ? "\n" : ""} 예약 환자를 확인하고
            {"\n"}환자별 초진차트를{isMobile ? "\n" : ""} 확인해요
          </div>
        </div>
      </motion.div>
    </div>
  );
}
